/** Delad transkription & live-rad mellan jaktdeltagare (LiveKit datakanal). */
export const TRANSCRIPT_DATA_V1 = 'qvenari_transcript_v1';
export const TRANSCRIPT_LIVE_V1 = 'qvenari_transcript_live_v1';
/** Text/bild i jaktlive-chatt (LiveKit data). */
export const HUNT_CHAT_MSG_V1 = 'qvenari_hunt_chat_v1';
/** GPS-position broadcast mellan deltagare. */
export const HUNT_POSITION_V1 = 'qv:pos:1';

export const KARTA_PREFS_STORAGE_KEY = 'qvenari_karta_prefs_v1';

export const VILTSLAG_LIST = [
  'Älgtjur Skovel','Älgtjur 10-taggare','Älgtjur 4-taggare','Älgtjur Spets','Älgko','Älgkviga','Älgkalv',
  'Kronhjort Kapital','Kronhjort >10 taggar','Kronhjort Spets','Kronhind','Kronkalv',
  'Dovhelskovel','Dovhalvskovel','Dovspets','Dovhind','Dovkalv',
  'Råbock Medalj','Råbock 6-taggare','Råbock 4-taggare','Råbock Spets','Råget','Smaldjur','Råkid',
  'Vildsvin Sugga','Vildsvin Galt','Vildsvin Årsgris','Vildsvin Kulting',
  'Mufflon Kapital bagge','Mufflon Mindre bagge','Mufflon Tacka','Mufflon Lamm',
  'Björn','Lodjur','Varg','Ren','Hare','Fasan','Orre','Ripa','Grågås','Kanadagås','And','Räv','Mink','Mårdhund','Grävling','Bäver',
];

/** Viltslag som aldrig ska visas i skjutmeny eller avskjutningsplan. */
export const HIDDEN_GAME_FAMILIES = new Set(['tjader', 'orre']);

export const STATUS_CONFIG: Record<string, { label: string; color: string }> = {
  fallt:    { label: 'Fällt',   color: '#E53935' },
  urtaget:  { label: 'Urtaget', color: '#EE8F09' },
  hangd:    { label: 'Hängd',   color: '#8B4513' },
  styckad:  { label: 'Styckad', color: '#61D836' },
};

export type PinType = 'pass' | 'atel' | 'observation' | 'skjutet_vilt' | 'ovrigt' | 'kamera';

export const PIN_CONFIG: Record<PinType, { color: string; label: string; bgColor: string }> = {
  pass:         { color: '#61D836', label: 'Pass',         bgColor: '#F1FDE8' },
  atel:         { color: '#8B4513', label: 'Åtel',         bgColor: '#EFEBE9' },
  observation:  { color: '#00A2FF', label: 'Observation',  bgColor: '#E3F2FD' },
  skjutet_vilt: { color: '#E53935', label: 'Skjutet vilt', bgColor: '#FFEBEE' },
  ovrigt:       { color: '#4E594C', label: 'Övrigt',       bgColor: '#F5F5F5' },
  // Åtelkameror ligger i mark_cameras (inte mark_pins); typen används bara när de placeras på kartan.
  kamera:       { color: '#EE8F09', label: 'Åtelkamera',   bgColor: '#FFF3E0' },
};

export function isPinType(type: unknown): type is PinType {
  return typeof type === 'string' && Object.prototype.hasOwnProperty.call(PIN_CONFIG, type);
}

/** Okända typer från databasen (t.ex. "samlingsplats") visas som Övrigt i stället för att krascha kartan. */
export function toPinType(type: unknown): PinType {
  return isPinType(type) ? type : 'ovrigt';
}

export function pinConfig(type: unknown) {
  return PIN_CONFIG[toPinType(type)];
}

export type BaseMapType = 'mapnik' | 'satellite' | 'terrain';
export const BASE_MAP_TYPES: readonly BaseMapType[] = ['mapnik', 'satellite', 'terrain'];
